import React from 'react';
import { Grid } from '@mui/system';
import { LINK_TYPE_OPTIONS } from '../constants';
import { Dropdown, InputListTemplateProps, TextInput } from 'framework/form';

const LinksInputTemplate = ({ source }: InputListTemplateProps) => {
  return (
    <Grid container size={6} spacing={2}>
      <Grid size={6}>
        <Dropdown source={`${source}.type`} label={'Link type'} options={LINK_TYPE_OPTIONS} />
      </Grid>
      <Grid size={6}>
        <TextInput source={`${source}.url`} label={'Link'} />
      </Grid>
    </Grid>
  );
};

export default LinksInputTemplate;
